export default function FeedSkeleton({ count = 12 }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-white dark:bg-gray-800 rounded-2xl overflow-hidden shadow-lg animate-pulse"
        >
          {/* Photo skeleton */}
          <div className="aspect-[4/5] bg-gray-200 dark:bg-gray-700" />

          {/* Info skeleton */}
          <div className="p-4 space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-gray-200 dark:bg-gray-700 rounded" />
                <div className="h-4 w-8 bg-gray-200 dark:bg-gray-700 rounded" />
              </div>
              <div className="h-5 w-16 bg-gray-200 dark:bg-gray-700 rounded" />
            </div>

            {/* Button skeletons */}
            <div className="flex gap-2">
              <div className="flex-1 h-10 bg-gray-200 dark:bg-gray-700 rounded-xl" />
              <div className="flex-1 h-10 bg-gray-200 dark:bg-gray-700 rounded-xl" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
